export default "__VITE_ASSET__4ef11de2__"